import styled from "styled-components";

export const TooltipBox = styled.div`
  background: white;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 6px 10px;
  font-size: 13px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
`;

export const TooltipRow = styled.div`
  display: flex;
  align-items: center;
`;

export const TooltipDot = styled.span<{ dotColor: string }>`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(props) => props.dotColor};
  margin-right: 5px;
  flex-shrink: 0;
`;

export const TooltipColon = styled.span`
  margin-right: 4px;
`;
